module.exports = __webpack_public_path__ + "static/media/Galdisa_Cheddar_cheese.53772341.pdf";